// extracted by mini-css-extract-plugin
module.exports = {"legend":"slider-module__legend___1l50V","legend-text":"slider-module__legend-text___3c3XF","legendText":"slider-module__legend-text___3c3XF"};